// Auth
export const urlRefreshToken = 'auth/refresh-token';
export const urlApiAuth = {
  login: 'auth/login',
  refreshToken: 'auth/refresh-token',
};

// Profile
export const urlApiUser = {
  getList: 'users/profile',
  updateProfile: 'users/profile',
  getStudents: 'users/students',
};

// Notifications
export const urlNotifications = {
  getList: 'notifications',
};

// Course
export const urlApiCourse = {
  getList: 'courses/upcoming',
  getDetail: (coursesId: string, moduleId: string) => `courses/${coursesId}/modules/${moduleId}`,
  getCoursesOfStudent: 'courses/of-student',
  getModulesOfCourse: (coursesId: string) => `courses/${coursesId}/modules`,
};

// Canvas
export const urlApiCanvas = {
  signIn: 'canvas/auth-url',
  createCanvasToken: 'canvas/token',
};

// Tuition
export const urlTuition = {
  getList: 'tuitions',
  create: 'tuitions/new',
};

// Exam
export const urlExam = {
  getList: 'exams',
  create: 'exams/new',
};
